import { forEachNode } from "../../utils/forEachNode";

export class Entities {
    constructor(targetClass, callback) {
        this.entities = document.querySelectorAll(targetClass);

        forEachNode(this.entities, (entity) => entity.addEventListener(
            'click',
            () => callback(entity)
        ));
    }
}